import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import _classCallCheck from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module clipboard/datatransfer
 */

/**
 * Facade over the native [`DataTransfer`](https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer) object.
 */
var DataTransfer =
/*#__PURE__*/
function () {
  function DataTransfer(nativeDataTransfer) {
    _classCallCheck(this, DataTransfer);

    /**
     * The array of files created from the native `DataTransfer#files` or `DataTransfer#items`.
     *
     * @readonly
     * @member {Array.<File>} #files
     */
    this.files = getFiles(nativeDataTransfer);
    /**
     * The native DataTransfer object.
     *
     * @private
     * @member {DataTransfer} #_native
     */

    this._native = nativeDataTransfer;
  }
  /**
   * Returns an array of available native content types.
   *
   * @returns {Array.<String>}
   */


  _createClass(DataTransfer, [{
    key: "getData",

    /**
     * Gets data from the data transfer by its mime type.
     *
     *		dataTransfer.getData( 'text/plain' );
     *
     * @param {String} type The mime type. E.g. `text/html` or `text/plain`.
     * @returns {String}
     */
    value: function getData(type) {
      return this._native.getData(type);
    }
    /**
     * Sets data in the data transfer.
     *
     * @param {String} type The mime type. E.g. `text/html` or `text/plain`.
     * @param {String} data
     */

  }, {
    key: "setData",
    value: function setData(type, data) {
      this._native.setData(type, data);
    }
  }, {
    key: "types",
    get: function get() {
      return this._native.types;
    }
  }]);

  return DataTransfer;
}();

export { DataTransfer as default };

function getFiles(nativeDataTransfer) {
  // DataTransfer.files and items are Array-like and might not have an iterable interface.
  var files = nativeDataTransfer.files ? Array.from(nativeDataTransfer.files) : [];
  var items = nativeDataTransfer.items ? Array.from(nativeDataTransfer.items) : [];

  if (files.length) {
    return files;
  } // Chrome have empty DataTransfer.files, but let get files through the items interface.


  return items.filter(function (item) {
    return item.kind === 'file';
  }).map(function (item) {
    return item.getAsFile();
  });
}